import * as React from "react";

import { All } from "./All";

import { Fragment } from "redux-little-router";

export const Base: React.FunctionComponent = () => {
    return (
        <div>
            <Fragment forRoute="/">
                <All />
            </Fragment>
        </div>
    );
};
